export const servicesConstants = {
  GETALL_REQUEST: "SERVICES_GETALL_REQUEST",
  GETALL_SUCCESS: "SERVICES_GETALL_SUCCESS",
  GETALL_FAILURE: "SERVICES_GETALL_FAILURE",

  DEPLOY_REQUEST: "SERVICES_DEPLOY_REQUEST",
  DEPLOY_SUCCESS: "SERVICES_DEPLOY_SUCCESS",
  DEPLOY_FAILURE: "SERVICES_DEPLOY_FAILURE",
};
